import React from 'react';
import Helmet from 'react-helmet';
import {
  url,
  defaultDescription,
  social,
  defaultTitle,
  socialLinks,
  address,
  contact,
  legalName,
  foundingDate,
  logo,
} from 'Data';

export const SEO = ({
  title = defaultTitle,
  description = defaultDescription,
  location = '',
}) => {
  const structuredDataOrganization = `{ 
		"legalName": "${legalName}",
		"url": "${url}",
		"logo": "${logo}",
		"founders": [{
			"@type": "Person",
			"name": "${legalName}"
		}],
		"contactPoint": [{
			"@type": "ContactPoint",
			"email": "${contact.email}",
		}],
		"sameAs": [
			"${socialLinks.linkedin}",
			"${socialLinks.instagram}",
			"${socialLinks.github}"
		]
  	}`;

  return (
    <Helmet>
      <meta name="description" content={description} />

      <meta property="og:type" content="website" />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />

      <link
        rel="stylesheet"
        href="https://fonts.googleapis.com/css?family=Sen:300,700&display=swap"
      />

      <script type="application/ld+json">{structuredDataOrganization}</script>
      <script
        src="https://kit.fontawesome.com/08a9bc197a.js"
        crossorigin="anonymous"
      ></script>
      <title>{title}</title>
      <html lang="en" dir="ltr" />
    </Helmet>
  );
};
